import React from 'react';

const Screen2: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background" style={{backgroundColor: '#0f172a'}}>
      <div className="text-center">
        <h1 className="text-4xl font-bold text-foreground">Screen 2</h1>
        <p className="text-muted-foreground">This is the second screen of your app.</p>
      </div>
    </div>
  );
};

export default Screen2;
